import useSession from "./useSession";

function usePromo() {
  const [session] = useSession();

  return session.promo;
}

export default usePromo;
